import EventEmitter from "events";

abstract class BaseHandler extends EventEmitter {
  abstract initialize(): void;
  abstract destroy(): void;
}

export default BaseHandler;
